import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';

import type { ResultadoEnvioPorEmail } from '../../shared/api/tipos.ts';
import { copiar } from '../../shared/copiar.ts';
import { formatarData } from '../../shared/format.ts';

/**
 * O que o servidor respondeu depois de mandar o período.
 *
 * Os dois links aparecem **uma vez só**, aqui: nenhuma listagem os devolve
 * depois, como o token do agente. Copiar agora é o que resolve o contador que
 * pede o material por outro canal — sem isso, só reenviando o e-mail. E a
 * lista de destinatários é a que o servidor resolveu no instante do envio: é
 * ela que prova para onde o documento fiscal foi, não a prévia do diálogo.
 */
export function AvisoDeEnvio({
  envio,
  aoFechar,
}: {
  envio: ResultadoEnvioPorEmail;
  aoFechar: () => void;
}) {
  return (
    <Alert severity="success" onClose={aoFechar}>
      <AlertTitle>
        Link de {envio.rotuloDoPeriodo} enviado — {envio.quantidade} nota(s)
      </AlertTitle>
      <Typography variant="body2">Para: {envio.destinatarios.join(', ')}</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
        O link vale até {formatarData(envio.validoAte)}.
      </Typography>

      <Stack direction="row" spacing={1} sx={{ mt: 1, flexWrap: 'wrap', gap: 1 }}>
        <Button
          size="small"
          variant="outlined"
          startIcon={<ContentCopyOutlinedIcon />}
          onClick={() => void copiar(envio.linkDownload)}
        >
          Copiar link do download
        </Button>
        <Button
          size="small"
          variant="outlined"
          startIcon={<ContentCopyOutlinedIcon />}
          onClick={() => void copiar(envio.linkPortal)}
        >
          Copiar link do portal
        </Button>
      </Stack>
    </Alert>
  );
}
